module.exports = __webpack_public_path__ + "media/configurations/SV_X-P-407f4b72.png";